/**
 * Pagination defaults and caps for App2, derived from Orval-generated OpenAPI artifacts in `./gen`.
 * Do not duplicate numeric literals elsewhere — import from `@/app2/shared/data` (re-exported here).
 */
import {
  ClientPaginationLimitsAdminUserRecentActivityFetchPageSize,
  ClientPaginationLimitsDefaultCoursesListPageSize,
  ClientPaginationLimitsDefaultCohortsListPageSize,
  ClientPaginationLimitsDefaultInternalScheduledReportsPageSize,
  ClientPaginationLimitsDefaultLessonsListPageSize,
  ClientPaginationLimitsDefaultRecentActivityPageSize,
  ClientPaginationLimitsDefaultSearchCoursesPageSize,
  ClientPaginationLimitsDefaultStandardAdminListPageSize,
  ClientPaginationLimitsMaxAdminListPageSize,
  ClientPaginationLimitsMaxSearchCoursesPage,
  ClientPaginationLimitsMinPageSize,
} from './gen';

export const MIN_PAGE_SIZE = ClientPaginationLimitsMinPageSize.NUMBER_1;

export const MAX_ADMIN_LIST_PAGE_SIZE = ClientPaginationLimitsMaxAdminListPageSize.NUMBER_200;

export const DEFAULT_COURSES_LIST_PAGE_SIZE =
  ClientPaginationLimitsDefaultCoursesListPageSize.NUMBER_20;

export const DEFAULT_LESSONS_LIST_PAGE_SIZE =
  ClientPaginationLimitsDefaultLessonsListPageSize.NUMBER_20;

export const DEFAULT_STANDARD_ADMIN_LIST_PAGE_SIZE =
  ClientPaginationLimitsDefaultStandardAdminListPageSize.NUMBER_25;

export const DEFAULT_COHORTS_LIST_PAGE_SIZE =
  ClientPaginationLimitsDefaultCohortsListPageSize.NUMBER_100;

export const DEFAULT_SEARCH_COURSES_PAGE_SIZE =
  ClientPaginationLimitsDefaultSearchCoursesPageSize.NUMBER_100;

export const MAX_SEARCH_COURSES_PAGE = ClientPaginationLimitsMaxSearchCoursesPage.NUMBER_1000;

export const DEFAULT_RECENT_ACTIVITY_PAGE_SIZE =
  ClientPaginationLimitsDefaultRecentActivityPageSize.NUMBER_10;

export const DEFAULT_INTERNAL_SCHEDULED_REPORTS_PAGE_SIZE =
  ClientPaginationLimitsDefaultInternalScheduledReportsPageSize.NUMBER_10;

export const ADMIN_USER_RECENT_ACTIVITY_FETCH_PAGE_SIZE =
  ClientPaginationLimitsAdminUserRecentActivityFetchPageSize.NUMBER_100;

/** MUI presets: anchored to OpenAPI defaults + max; midpoints are UI-only (not separate OpenAPI fields). */
export const PAGE_SIZE_OPTIONS_COURSES_ADMIN = [
  DEFAULT_COURSES_LIST_PAGE_SIZE,
  DEFAULT_STANDARD_ADMIN_LIST_PAGE_SIZE,
  50,
  100,
  MAX_ADMIN_LIST_PAGE_SIZE,
] as const;

export const PAGE_SIZE_OPTIONS_STANDARD_ADMIN = [
  DEFAULT_STANDARD_ADMIN_LIST_PAGE_SIZE,
  50,
  100,
  MAX_ADMIN_LIST_PAGE_SIZE,
] as const;

export const PAGE_SIZE_OPTIONS_TEAM_PROGRESS = [
  10,
  DEFAULT_STANDARD_ADMIN_LIST_PAGE_SIZE,
  50,
  100,
  MAX_ADMIN_LIST_PAGE_SIZE,
] as const;
